exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clozeCustomizerContainer .clozeInstructions{margin-top:2rem}.clozeCustomizerContainer .testDatePicker{margin-bottom:1rem;width:10rem;border-radius:3px;border:1px solid #ccc;padding:2px 4px}.clozeCustomizerContainer .removeRowLink{color:#c31030}.clozeCustomizerContainer .paywallModal .modal-dialog{max-width:88%}.clozeCustomizerContainer .previewImage{max-width:80%;border:1px solid #ccc;margin-bottom:20px}.clozeCustomizerContainer .previewMessage{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/cloze_customizer.scss
// module id = 1440
// module chunks = 0